<nz-row nzGutter="24">
  <nz-col [nzSm]="24">
    <r-widget-control [control]="firstnameControl">
      <input
        nz-input
        [name]="config.name"
        [placeholder]="config.placeholder"
        ngDefaultControl
        #firstnameControl="ngModel"
        [(ngModel)]="config.value"
        (ngModelChange)="onChange($event)"
        [required]="config.required"
        [disabled]="config.disabled"
      />
    </r-widget-control>
  </nz-col>
  <nz-col [nzSm]="24" *ngIf="config.effective.length">
    <app-effective-display [config]="config"> </app-effective-display>
  </nz-col>
</nz-row>
